import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as R from 'ramda';
import { getMenuSettingsConfig } from '@constants/config';
import { verifyPermissions } from '@utils/permission-utils';
import './menu.scss';
import UnstyledHeading from '@components/shared/unstyled-heading';

const SETTINGS_MENU_HEADER_ID = 'settings-menu-header';

const Menu = () => {
  const location = useLocation();

  const isActive = type => {
    const { pathname } = location;
    const nameSlice = R.slice(2, 3);
    const name = R.pipe(R.split('/'), nameSlice)(pathname)[0];
    return type === name;
  };

  const renderMenuItem = item => {
    const { label, permissions, type } = item;
    if (!verifyPermissions(permissions)) {
      return null;
    }
    const active = isActive(type);
    return (
      <Link
        aria-current={active ? 'page' : null}
        data-testid="settings-menu-item"
        key={type}
        to={`/settings/${type}`}
        styleName={`menu-item ${active ? 'active' : ''}`}
      >
        {label}
      </Link>
    );
  };

  const items = getMenuSettingsConfig();
  return (
    <nav data-testid="settings-menu" styleName="menu-container" aria-labelledby={SETTINGS_MENU_HEADER_ID}>
      <UnstyledHeading rank={2} id={SETTINGS_MENU_HEADER_ID} ariaOnly>settings menu</UnstyledHeading>
      {items.map(item => renderMenuItem(item))}
    </nav>
  );
};

export default Menu;
